import { render, staticRenderFns } from "./AppContentSubjectEdit.vue?vue&type=template&id=efee8a84&scoped=true&"
import script from "./AppContentSubjectEdit.vue?vue&type=script&lang=js&"
export * from "./AppContentSubjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppContentSubjectEdit.vue?vue&type=style&index=0&id=efee8a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee8a84",
  null
  
)

export default component.exports